// frontend/src/components/common/DynamicMeta.js
import React, { useEffect } from 'react';

function DynamicMeta({ title, description, image, url }) {
  useEffect(() => {
    // 1. Set the standard document title
    document.title = title;

    // 2. Define the meta tags to update/create
    const metaTags = [
      // Standard SEO
      { name: 'description', content: description },
      
      // Open Graph (Facebook, WhatsApp, LinkedIn)
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: image },
      { property: 'og:url', content: url },
      { property: 'og:type', content: 'website' },
      
      // Twitter Card
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
    ];

    // 3. Function to update/create tags
    metaTags.forEach(tag => {
      let element;
      
      if (tag.name) {
        // Find by name (for Twitter/Standard tags)
        element = document.querySelector(`meta[name='${tag.name}']`);
      } else if (tag.property) {
        // Find by property (for Open Graph tags)
        element = document.querySelector(`meta[property='${tag.property}']`);
      }

      if (element) {
        // Update existing tag
        element.setAttribute(tag.name ? 'content' : 'content', tag.content);
      } else {
        // Create new tag
        element = document.createElement('meta');
        if (tag.name) element.setAttribute('name', tag.name);
        if (tag.property) element.setAttribute('property', tag.property);
        element.setAttribute('content', tag.content);
        document.head.appendChild(element);
      }
    });

    // Cleanup function to reset the title when the component unmounts
    return () => {
      document.title = "Everything Automotive";
    };
  }, [title, description, image, url]);

  return null;
}

export default DynamicMeta;